// removed by extract-text-webpack-plugin
module.exports = {"Profile":"Profile--3vYYx","gravatar":"gravatar--2oFV3"};